/* MAX-I.V. Hydration · theme.js
   Minimal interactions: subscription toggle pricing, cart count refresh,
   variant picker active state. PDP / FAQ wire themselves via inline scripts
   in the section files. */

(function () {
  'use strict';

  /* ============================================================
     PDP subscription tabs · toggle the .is-active state
     and swap the visible add-to-cart price.
     Actual recurring-billing logic must come from your subscription app.
     ============================================================ */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[name="purchase_type"]')) return;
    var tabs = document.querySelectorAll('.pdp__buy-tab');
    tabs.forEach(function (t) { t.classList.remove('is-active'); });
    var label = e.target.closest('label.pdp__buy-tab');
    if (label) label.classList.add('is-active');
  });

  /* ============================================================
     Cart count refresh on add-to-cart events
     ============================================================ */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* network errors are fine */ });
  }
  document.addEventListener('submit', function (e) {
    if (e.target.matches('form[action$="/cart/add"]')) {
      // give Shopify time to register the add, then refresh
      setTimeout(refreshCart, 600);
    }
  });

  /* ============================================================
     Variant radio active state (used by PDP option pickers)
     ============================================================ */
  document.querySelectorAll('.pdp__variants').forEach(function (group) {
    group.addEventListener('change', function (e) {
      group.querySelectorAll('.pdp__variant').forEach(function (v) {
        v.classList.remove('is-active');
      });
      var label = e.target.closest('.pdp__variant');
      if (label) label.classList.add('is-active');
    });
  });

  /* ============================================================
     Product-card image carousel — swipe-snap with accent dots
     ============================================================ */
  function initProductCardCarousel(carousel) {
    var track = carousel.querySelector('[data-pcard-track]');
    var dotsWrap = carousel.querySelector('[data-pcard-dots]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.pcard-dot')) : [];

    function activate(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!slides[i]) return;
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            activate(slides.indexOf(entry.target));
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
  }
  document.querySelectorAll('[data-pcard-carousel]').forEach(initProductCardCarousel);
})();
